
import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <nav className="fixed top-0 left-0 w-full z-50 bg-white/80 shadow-lg backdrop-blur">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <img alt="Royal Trucking Logo" className="w-10 h-10 rounded-lg object-contain bg-white" src="/10LOGOS.webp" />
              <span className="ml-3 text-xl font-bold text-gray-900">Royal Trucking</span>
            </Link>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                `px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${isActive ? 'text-white bg-orange-700' : 'text-gray-700 hover:text-white hover:bg-orange-700'}`
              }
            >
              Inicio
            </NavLink>
            <NavLink
              to="/servicios"
              className={({ isActive }) =>
                `px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${isActive ? 'text-white bg-orange-700' : 'text-gray-700 hover:text-white hover:bg-orange-700'}`
              }
            >
              Servicios
            </NavLink>
            <NavLink
              to="/flota"
              className={({ isActive }) =>
                `px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${isActive ? 'text-white bg-orange-700' : 'text-gray-700 hover:text-white hover:bg-orange-700'}`
              }
            >
              Flota
            </NavLink>
            <NavLink
              to="/seguimiento"
              className={({ isActive }) =>
                `px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${isActive ? 'text-white bg-orange-700' : 'text-gray-700 hover:text-white hover:bg-orange-700'}`
              }
            >
              Seguimiento
            </NavLink>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                `px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${isActive ? 'text-white bg-orange-700' : 'text-gray-700 hover:text-white hover:bg-orange-700'}`
              }
            >
              Nosotros
            </NavLink>
            <NavLink
              to="/contacto"
              className={({ isActive }) =>
                `px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${isActive ? 'text-white bg-orange-700' : 'text-gray-700 hover:text-white hover:bg-orange-700'}`
              }
            >
              Contacto
            </NavLink>
            <NavLink
              to="/blog"
              className={({ isActive }) =>
                `px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${isActive ? 'text-white bg-orange-700' : 'text-gray-700 hover:text-white hover:bg-orange-700'}`
              }
            >
              Blog
            </NavLink>
            <a href="https://wa.me/51904601791" target="_blank" rel="noopener noreferrer" className="bg-orange-700 text-white px-6 py-2 rounded-md text-sm font-medium hover:bg-orange-800 transition-colors duration-200">Cotizar</a>
          </div>
          {/* Menú móvil */}
          <div className="md:hidden flex items-center">
            <button
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-orange-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-orange-500"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Abrir menú principal"
            >
              <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      {/* Menú desplegable móvil */}
      {menuOpen && (
        <div className="md:hidden bg-white/95 shadow-lg backdrop-blur absolute w-full left-0 top-16 z-50 animate-fade-in">
          <div className="flex flex-col px-4 py-4 space-y-2">
            <NavLink to="/" end className={({ isActive }) => `px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${isActive ? 'text-white bg-orange-700' : 'text-gray-700 hover:text-white hover:bg-orange-700'}`} onClick={() => setMenuOpen(false)}>Inicio</NavLink>
            <NavLink to="/servicios" className={({ isActive }) => `px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${isActive ? 'text-white bg-orange-700' : 'text-gray-700 hover:text-white hover:bg-orange-700'}`} onClick={() => setMenuOpen(false)}>Servicios</NavLink>
            <NavLink to="/flota" className={({ isActive }) => `px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${isActive ? 'text-white bg-orange-700' : 'text-gray-700 hover:text-white hover:bg-orange-700'}`} onClick={() => setMenuOpen(false)}>Flota</NavLink>
            <NavLink to="/seguimiento" className={({ isActive }) => `px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${isActive ? 'text-white bg-orange-700' : 'text-gray-700 hover:text-white hover:bg-orange-700'}`} onClick={() => setMenuOpen(false)}>Seguimiento</NavLink>
            <NavLink to="/about" className={({ isActive }) => `px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${isActive ? 'text-white bg-orange-700' : 'text-gray-700 hover:text-white hover:bg-orange-700'}`} onClick={() => setMenuOpen(false)}>Nosotros</NavLink>
            <NavLink to="/contacto" className={({ isActive }) => `px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${isActive ? 'text-white bg-orange-700' : 'text-gray-700 hover:text-white hover:bg-orange-700'}`} onClick={() => setMenuOpen(false)}>Contacto</NavLink>
            <NavLink to="/blog" className={({ isActive }) => `px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${isActive ? 'text-white bg-orange-700' : 'text-gray-700 hover:text-white hover:bg-orange-700'}`} onClick={() => setMenuOpen(false)}>Blog</NavLink>
            <a href="https://wa.me/51904601791" target="_blank" rel="noopener noreferrer" className="bg-orange-700 text-white px-6 py-2 rounded-md text-sm font-medium hover:bg-orange-800 transition-colors duration-200 text-center">Cotizar</a>
          </div>
        </div>
      )}
    </nav>
  );
};


export default Navbar;
